export default {
  trackingInfoRequired: 'Tracking information is required to receive payouts for orders placed on or after May 13, 2026.',
  shippingInstructions: 'Ship within 3 business days of the order date and enter your tracking in the order details.',
  learnMore: 'Learn more about our payout timelines.',
};
